/**
 * This file will configure various resources for your application.
 * - Logging to New Relic (More configuration required - see below)
 * - Analytics tracking through Adobe Target Events
 *
 * Anything else required before your app is loaded can be included in this
 * file.
 */

import {
  configAnalytics,
  configNewRelic,
} from "@origin-digital/reporting-client";
import { configFetch } from "@origin-digital/daxi";

import { config, appName } from "src/config";

const envAppName = `${appName}-${config.env}`;

configAnalytics({
  appName,
  debugToConsole: config.analyticsDebugToConsole,
});

// Local and functional environments intentionally omit remote logging credentials.
if (config.newRelicCollectorKey) {
  configNewRelic({
    logLevel: config.logLevelNewRelic,
    consoleLogLevel: config.logLevelConsole,
    sendOnErrors: true,
    appName: envAppName,
    endpoint: "https://log-api.newrelic.com/log/v1",
    apiKey: config.newRelicCollectorKey,
    sourceEnv: config.env,
  });
}

configFetch({
  disableAuthCheck: false,
  environment: config.env,
});
